export const ORG_REGISTER_REQUEST = 'ORG_REGISTER_REQUEST' // Регистрация запроса
export const ORG_TYPES_REQUEST = 'ORG_TYPES_REQUEST' // Запрос списка типов учреждений
export const ORG_FORMS_REQUEST = 'ORG_FORMS_REQUEST' // Запрос списка организационно-правовых форм учреждений
export const ORG_SET_ORG = 'ORG_SET_ORG' // Установка текущей организации
export const ORG_UPDATE = 'ORG_UPDATE' // Обновление данных текущей организации
export const ORG_LIST_REQUEST = 'ORG_LIST_REQUEST' // Запрос списка организаций

export const ORG_PROFILE_REQUEST = 'ORG_PROFILE_REQUEST'
export const ORG_PROFILE_UPDATE = 'ORG_PROFILE_UPDATE'

export const ORG_GET_STRUCTURE = 'ORG_GET_STRUCTURE'
export const ORG_CLEAR_STRUCTURE = 'ORG_CLEAR_STRUCTURE'
export const ORG_GET_DEPTS = 'ORG_GET_DEPTS'

export const ORG_GET_POSITIONS = 'ORG_GET_POSITIONS'
export const ORG_ADD_POSITION = 'ORG_ADD_POSITION'
export const ORG_UPD_POSITION = 'ORG_UPD_POSITION'
export const ORG_DEL_POSITION = 'ORG_DEL_POSITION'

export const ORG_ADD_EMPLOEE = 'ORG_ADD_EMPLOEE'
export const ORG_UPD_EMPLOEE = 'ORG_UPD_EMPLOEE'
export const ORG_MOVE_EMPLOEE = 'ORG_MOVE_EMPLOEE'
export const ORG_LOCK_EMPLOEE = 'ORG_LOCK_EMPLOEE'

export const ORG_SET_USER = 'ORG_SET_USER'
export const ORG_SET_NEW_PWD = 'ORG_SET_NEW_PWD'
export const ORG_ADD_USER_CONTACT = 'ORG_ADD_USER_CONTACT'
export const ORG_UPD_USER_CONTACT = 'ORG_UPD_USER_CONTACT'
export const ORG_DEL_USER_CONTACT = 'ORG_DEL_USER_CONTACT'
export const ORG_SET_PO_USER = 'ORG_SET_PO_USER'
export const ORG_LOCK_PO_USER = 'ORG_LOCK_PO_USER'

export const ORG_ADD_USER_ROLE = 'ORG_ADD_USER_ROLE'
export const ORG_UPD_USER_ROLE = 'ORG_UPD_USER_ROLE'

export const ORG_SET_USER_CONTACT_MAIN = 'ORG_SET_USER_CONTACT_MAIN'

export const ORG_GET_DEPT_USERS = 'ORG_GET_DEPT_USERS'
export const ORG_GET_TECHADMINS = 'ORG_GET_TECHADMINS'
export const ORG_GET_DIV_USERS = 'ORG_GET_DIV_USERS'

export const ORG_GET_DIVISION_LIST = 'ORG_GET_DIVISION_LIST'
export const ORG_ADD_DIVISION = 'ORG_ADD_DIVISION'
export const ORG_UPD_DIVISION = 'ORG_UPD_DIVISION'
export const ORG_SET_DIVISION = 'ORG_SET_DIVISION'
export const ORG_DEL_DIVISION = 'ORG_DEL_DIVISION'

export const ORG_SEND_CREDENTIALS = 'ORG_SEND_CREDENTIALS'

export const ORG_FREE_DATA = 'ORG_FREE_DATA'
export const ORG_GET_ORG = 'ORG_PROFILE_REQUEST'
export const ORG_DEL_EMPLOEE_BOSS = 'ORG_DEL_EMPLOEE_BOSS'
